export default {
	['NAV_URL']({
		commit
	}, payload) {
		commit('NAV_URL', payload);
	}
};
